/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('LikeCtrl', function($scope, ngNotify, identity, Message, ErrorThrower) {
    $scope.me            = identity;
    $scope.display_likes = false;
    const errorManager         = new ErrorThrower;

    $scope.toggleDisplay = () => $scope.display_likes = !$scope.display_likes;

    const likeFilter = like_value => $scope.message.likes.filter(like => like.like === like_value);

    const init = function() {
        $scope.my_like     = $scope.message.likes.filter(like => like.user === $scope.me.id).pop();
        $scope.karma_minus = likeFilter(false);
        $scope.karma_plus  = likeFilter(true);

        const nb_plus  = $scope.karma_plus.length;
        const nb_minus = $scope.karma_minus.length;
        const is_hated = (10 < nb_minus) && (nb_minus >= (nb_plus * 3));
        const {
            roles
        } = $scope.message.author;

        return $scope.message.karma_police = (!Array.from(roles).includes('adm') && !Array.from(roles).includes('prepintra_adm')) && (true === is_hated);
    };

    init();

    $scope.removeLike = () => Message
    .removeLike({
        conversation_id: $scope.conversation_id,
        message_id:      $scope.message.id}).$promise
    .then(new_like => (() => {
        const result = [];
        for (let like of Array.from($scope.message.likes)) {
            if ($scope.me.id === like.user) {
                like.like = null;
                break;
            } else {
                result.push(undefined);
            }
        }
        return result;
    })()).catch(error => errorManager.minor(error.statusText)).finally(() => init());

    return $scope.likeMessage = function(karma) {
        if (($scope.my_like != null) && (karma === $scope.my_like.like)) { return $scope.removeLike(); }

        return Message
        .addLike({
            conversation_id: $scope.conversation_id,
            message_id:      $scope.message.id,
            like:            karma}).$promise
        .then(function(new_like) {
            let like;
            for (like of Array.from($scope.message.likes)) {
                if ($scope.me.id === like.user) {
                    like.like = karma;
                    return;
                }
            }

            $scope.message.likes.push(new_like);
            if (true === new_like.like) { return $scope.karma_plus += 1; } else { return $scope.karma_minus += 1; }}).catch(error => errorManager.minor(error.statusText)).finally(() => init());
    };
});
